import { ref, watch } from "vue";

export const useDateFilter = () => {
  // 날짜 선택 옵션
  const dateOptions = ref([
    {
      value: "90",
      text: "지난 90일",
    },
    {
      value: "60",
      text: "지난 60일",
    },
    {
      value: "30",
      text: "지난 30일",
    },
    {
      value: "7",
      text: "지난 7일",
    },
    {
      value: "24",
      text: "지난 24시간",
    },
    {
      value: "date",
      text: "",
      date: true,
    },
  ]);

  const selectedType = ref(null);
  const selectRef = ref(null);
  const dateRange = ref({
    start: null,
    end: null,
  });

  // 날짜 필터링 함수
  const isDateInRange = (transactionDateStr, startDate, endDate) => {
    if (!startDate || !endDate) return true;

    // 날짜 문자열을 Date 객체로 변환 (형식: "2025-12-11 18:32")
    const [datePart] = transactionDateStr.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const transDate = new Date(year, month - 1, day);

    const start = new Date(startDate);
    const end = new Date(endDate);

    // 시간 부분 제거하고 날짜만 비교
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    transDate.setHours(0, 0, 0, 0);

    return transDate >= start && transDate <= end;
  };

  // 날짜 범위 계산 함수 (지난 N일)
  const getDateRangeFromDays = (days) => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - days);
    return {
      start: startDate,
      end: endDate,
    };
  };

  // Select change 핸들러
  const handleSelectChange = (value, index, extra) => {
    selectedType.value = value;
    // 날짜 범위가 있으면 업데이트
    if (extra && extra.dateRange) {
      dateRange.value = extra.dateRange;
    } else {
      // 날짜 옵션이 아닌 경우 날짜 범위 초기화
      const selectedOption = dateOptions.value.find((opt) => opt.value === value);
      if (!selectedOption || !selectedOption.date) {
        dateRange.value = { start: null, end: null };
      }
    }
  };

  // Select 컴포넌트의 dateRange 감시
  watch(
    () => selectRef.value?.dateRange,
    (newRange) => {
      if (newRange && newRange.start && newRange.end) {
        dateRange.value = {
          start: newRange.start,
          end: newRange.end,
        };
      }
    },
    { deep: true, immediate: true }
  );

  // 날짜 필터링 적용 함수
  const applyDateFilter = (transactions) => {
    if (!selectedType.value) return transactions;

    const selectedOption = dateOptions.value.find(
      (opt) => opt.value === selectedType.value
    );

    if (!selectedOption) return transactions;

    if (selectedOption.date) {
      // 날짜 범위 선택
      if (dateRange.value.start && dateRange.value.end) {
        return transactions.filter((transaction) =>
          isDateInRange(
            transaction.date,
            dateRange.value.start,
            dateRange.value.end
          )
        );
      }
    } else {
      // 지난 N일
      const days = parseInt(selectedOption.value);
      if (!isNaN(days)) {
        const range = getDateRangeFromDays(days);
        return transactions.filter((transaction) =>
          isDateInRange(transaction.date, range.start, range.end)
        );
      }
    }

    return transactions;
  };

  return {
    dateOptions,
    selectedType,
    selectRef,
    dateRange,
    isDateInRange,
    getDateRangeFromDays,
    handleSelectChange,
    applyDateFilter,
  };
};
